import * as AppActions from "./appActions";
import user from '../../data/user';
import api from '../../utils/api';
import moment from "moment/moment";
import {NotificationManager} from 'react-notifications';
import * as VideoActions from './videoActions';

export const ACTION_AUTH_LOGIN_REQUEST = 'ACTION_AUTH_LOGIN_REQUEST';
export const ACTION_AUTH_LOGIN_SUCCESS = 'ACTION_AUTH_LOGIN_SUCCESS';
export const ACTION_AUTH_LOGIN_FAILURE = 'ACTION_AUTH_LOGIN_FAILURE';
export const ACTION_AUTH_LOGOUT = 'ACTION_AUTH_LOGOUT';

export const ACTION_AUTH_REGISTER_REQUEST = 'ACTION_AUTH_REGISTER_REQUEST';
export const ACTION_AUTH_REGISTER_SUCCESS = 'ACTION_AUTH_REGISTER_SUCCESS';
export const ACTION_AUTH_REGISTER_FAILURE = 'ACTION_AUTH_REGISTER_FAILURE';
export const ACTION_AUTH_PASSWORD_RESET_REQUESTED = 'ACTION_AUTH_PASSWORD_RESET_REQUESTED';
export const ACTION_AUTH_PASSWORD_RESET_COMPLETED = 'ACTION_AUTH_PASSWORD_RESET_COMPLETED';
export const ACTION_AUTH_RESET_PASSWORD_RESET_STATUS = 'ACTION_AUTH_RESET_PASSWORD_RESET_STATUS';
export const ACTION_AUTH_RESET_PASSWORD_FAILED = 'ACTION_AUTH_RESET_PASSWORD_FAILED';

export const ACTION_AUTH_CLEAR = 'ACTION_AUTH_CLEAR';
export const ACTION_UPDATED_PROFILE = 'ACTION_UPDATED_PROFILE';
export const ACTION_UPDATED_USER = 'ACTION_UPDATED_USER';
export const ACTION_GOT_ALL_COURSES = 'ACTION_GOT_ALL_COURSES';
export const ACTION_GOT_PROFILE = 'ACTION_GOT_PROFILE';
export const UPLOADED_AVATAR = 'UPLOADED_AVATAR';

export const UPDATED_COURSE_USER = 'UPDATED_COURSE_USER';
export const INITIAL_TASKS = 'INITIAL_TASKS';
export const TASK_UPDATED = 'TASK_UPDATED';
export const TOKEN_SENT = 'TOKEN_SENT';
export const TOKEN_VERIFIED = 'TOKEN_VERIFIED';
export const TOKEN_WRONG = 'TOKEN_WRONG';
export const TASK_ADDED = 'TASK_ADDED';

export const OFFICIAL_TEST_RETRIEVED = "OFFICIAL_TEST_RETRIEVED";
export const OFFICIAL_TEST_ADDED = "OFFICIAL_TEST_ADDED";
export const OFFICIAL_TEST_UPDATED = "OFFICIAL_TEST_UPDATED";
export const OFFICIAL_TEST_DELETED = "OFFICIAL_TEST_DELETED";

/**
 * Validates username and password.
 *
 * @param username user name.
 * @param password user password.
 * @returns {boolean} true if right otherwise false.
 */
let userAccount;

function validateCredentials(username, password, browser, callback) {

    api.LoginUser({email: username, password: password, browser: browser}, (res) => {
        userAccount = res.data;
        callback(res);

    })
        //return (username === 'admin' && password === 'admin');
}

/**
 *
 */
function loginUserRequest() {
    return {type: ACTION_AUTH_LOGIN_REQUEST};
}

/**
 *
 * @param user authenticated user.
 */
function loginUserSuccess(user) {
    return {
        type: ACTION_AUTH_LOGIN_SUCCESS,
        payload: {user}
    };
}

function updatedUser(user) {
    return {
        type: ACTION_UPDATED_USER,
        payload: user
    }
}

export function updatedProfile(profile){
    return {
        type: ACTION_UPDATED_PROFILE,
        payload: profile
    }
}

function RegistrationSuccess(user) {
    return {
        type: ACTION_AUTH_REGISTER_SUCCESS,
        payload: {user}
    };
}

/**
 *
 * @param errorMessage description of error.
 */
export function loginUserFailure(errorMessage) {
    return {
        type: ACTION_AUTH_LOGIN_FAILURE,
        payload: {errorMessage}
    };
}

function passwordResetRequested(message){
    return {
        type: ACTION_AUTH_PASSWORD_RESET_REQUESTED,
        payload: {message}
    }
}

function passwordResetCompleted(message){
    return {
        type: ACTION_AUTH_PASSWORD_RESET_COMPLETED,
        payload: {message}
    }
}

export function resetPasswordResetStatus(){
    return {
        type: ACTION_AUTH_RESET_PASSWORD_RESET_STATUS
    };
}

function passwordResetFailed(passwordResetError){
    return {
        type: ACTION_AUTH_RESET_PASSWORD_FAILED,
        payload: {passwordResetError}
    }
}

export function clearErrors(){
    return {
        type: ACTION_AUTH_CLEAR,
        payload: {
            errorMessage: null,
            error: null,
            passwordResetError: null
        }
    }
}

function courseUserUpdated(cu){
    return {
        type: UPDATED_COURSE_USER,
        payload: cu
    }
}

export function setCourseUserNextStep(courseUser, token){
    return dispatch => {
        api.courseUserNextStep(courseUser, token, res => {
            dispatch(courseUserUpdated(res.data));
            dispatch(VideoActions.updatedCourseUser(res.data));
        });
    }
}

/**
 * Try authenticate user with credential.
 *
 * @param username
 * @param password
 */
export function loginUser(username, password, browser) {

    return (dispatch) => {
        dispatch(AppActions.appLoading(true));
        dispatch(loginUserRequest());
        dispatch(AppActions.setLoadingOverlayVisible());

        validateCredentials(username, password, browser, (res) => {
            if (res.status == 200) {
                let user = res.data;

                if(!user.courseList) {
                    user.courseList = [];
                }
                user.createdDate = moment(user.created).format("MMMM Do YYYY");


                dispatch(loginUserSuccess(user));

            } else {
                dispatch(AppActions.appLoading(false));
                dispatch(loginUserFailure("Username or password is invalid."));
            }

            dispatch(AppActions.setLoadingOverlayInvisible());
        })

    };
}


/***************************************
 * egister user
 */

export function RegisterUser(email, password, name, lname, role, image, google, fb, courseRegistration, browser) {


        return (dispatch) => {
            api.RegisterUser({email: email, password: password, name: name, lname: lname, role: role, image: image, google: google, fb: fb, courseRegistration: courseRegistration}, (registered) => {
                if(registered.status == 200) {


                    dispatch(loginUserRequest());
                    dispatch(AppActions.setLoadingOverlayVisible());

                    validateCredentials(email, password, browser, (res) => {
                        if (res.status == 200) {
                            let user = res.data;

                            if (!user.courseList) {
                                user.courseList = [];
                            }
                            
                            
                            dispatch(loginUserSuccess(user));
                            

                        } else {
                            dispatch(loginUserFailure(res.error.message));
                        }




                    });
                }else{
                    dispatch(loginUserFailure(registered.response.data.error.message));
                }

                dispatch(AppActions.setLoadingOverlayInvisible());
            });

        }

}

export function sendForgotPasswordEmail(email){
    return (dispatch) => {
        dispatch(AppActions.setLoadingOverlayVisible());
        dispatch({
            type: 'SENDING_EMAIL'
        })
        api.resetPassword({email: email}, res => {
            if(res.data.email.status === 404){
                dispatch(passwordResetFailed(res.data.email.message));
            }else {
                dispatch(passwordResetRequested(res.data.email.message));
            }
        });
        dispatch(AppActions.setLoadingOverlayInvisible());
    }
}

export function resetPassword(token, password){
    return (dispatch) => {
        dispatch(AppActions.setLoadingOverlayVisible());
        api.resetPasswordWithToken({access_token: token, password: password}, res => {
            if(res.status === 200){
                dispatch(passwordResetCompleted(res));
            }
        })
        dispatch(AppActions.setLoadingOverlayInvisible());
    }

}

export function updateUser(token, user){
    return (dispatch) => {
        delete user.passwordAgain;
        delete user.oldPassword;
        api.updateUser(token, user, res => {
            dispatch(updatedUser(res.data));
            NotificationManager.success("Your account has been updated.");
        })
    }
}

export function deleteUser(id, token){
    return dispatch => {
        dispatch({
            type: 'SET_DELETING_LOADING',
            payload: true
        });

        api.deleteUser(id, token, res => {
            if(res.status === 200){
                NotificationManager.success('User has been deleted');
                dispatch({
                    type: 'DELETED_USER',
                    payload: {
                        id: id,
                        deletedObjects: res.data.deletedObjects
                    }
                });
            }
        })
    }
}

export function resetModalDisplay(mode) {
    return dispatch => {
        dispatch({
            type: 'RESET_MODAL_DISPLAY',
            payload: mode
        })
    }
}

function profileUpdated(profile){
    return {
        type: ACTION_GOT_PROFILE,
        payload: profile
    }
}


export function updateProfile(profile, token){
    return dispatch => {
        api.updateProfile(profile, token, res => {
            dispatch(profileUpdated(res.data));
        });
    }
}

/**
 * Return action to logout user.
 */
export function logoutUserAction() {
    // Clear local storage on logout!
    window.localStorage.clear();
    return {type: ACTION_AUTH_LOGOUT};
    
}

function gotUsers(users, skip){
    return {
        type: 'GOT_USERS',
        payload: users,
        skip: skip
    }
}

export function getUsers(token, skip){
    return dispatch => {
        api.getUsers(token, skip, res => {
            dispatch(gotUsers(res.data.data, skip));
        })
    }
}

export function getCourseUserForProfile(cuId, token){
    return dispatch => {
        api.getSingleCourseUserForProfile(cuId, token, res => {
            dispatch({
                type: 'ADD_CU_TO_PROFILE',
                payload: res.data
            })
        })
    }
}

export function findUsers(where, token, skip){
    return dispatch => {
        api.findUsers(where, token, skip, res => {
            dispatch(gotUsers(res.data.data, skip));
        })
    }
}

function gotAllCourses(data){
    return {
        type: ACTION_GOT_ALL_COURSES,
        payload: data
    }
}

export function getAllCourses(){
    return (dispatch) => {
        api.getAllCourses(res => {
            dispatch(gotAllCourses(res.data));
        })
    }
}

function gotProfile(profile){
    return {
        type: ACTION_GOT_PROFILE,
        payload: profile
    }

}

export function getProfile(profileId, token){
    return dispatch => {
        api.getProfile(profileId, token, res => {
            if(res.status === 200){
                dispatch(gotProfile(res.data));
            }else{
                NotificationManager.error("Could not get profile", "Error");
            }
        })
    }
}

function uploadedAvatar(res){
    return {
        type: UPLOADED_AVATAR,
        payload: res
    }
}

export function uploadAvatar(data, profileId, token){
    return dispatch => {
        api.uploadAvatar(data, profileId, token, res => {
            dispatch(getProfile(profileId, token));
        })
    }
}

export function setInitialTasks(tasks){
    return {
        type: INITIAL_TASKS,
        payload: tasks
    }
}

export function updateTask(task){
    return {
        type: TASK_UPDATED,
        payload: task
    }
}

export function addTask(task){
    return {
        type: TASK_ADDED,
        payload: task
    }
}

function tokenSent(user){
    return {
        type: TOKEN_SENT,
        payload: user
    }
}

export function sendAllTokens(token){
    return dispatch => {
        api.sendAllTokens(token, res => {
            if(res.status === 200){
                dispatch(tokenSent(res.data)); 
                NotificationManager.success('Verification Emails Sent!');
            }else{
                NotificationManager.error('Error Sending Emails');
            }

        })
    }
}

export function sendToken(user, token){
    return dispatch => {
        api.sendToken(user, token, res => {
            if(res.status === 200){
                dispatch(tokenSent(res.data)); 
                NotificationManager.success('Verification Email Sent!');
            }else{
                NotificationManager.error('Error Sending Email');
            }

        })
    }
}

function tokenVerified(data){
    return {
        type: TOKEN_VERIFIED,
        payload: data
    }
}

function tokenWrong(data){
    return {
        type: TOKEN_WRONG,
        payload: data
    }
}

export function verifyCode(user, code, email){
    return dispatch => {
        api.verifyCode(user, code, email, res => {
            if(res.data.email.verified){
                if(email == user.email){
                    
                    dispatch(tokenVerified(res.data));
                    setTimeout(function(){
                        NotificationManager.success("Your account has been verified.");
                    }, 1000);
                }else{
                    NotificationManager.success(email + " has been verified.");
                }
            }else{
                dispatch(tokenWrong(res.data));
            }
        })
    }
}

function officialTestsRetrieved(tests){
    return {
        type: OFFICIAL_TEST_RETRIEVED,
        payload: tests
    }
}

function officialTestAdded(test){
    return {
        type: OFFICIAL_TEST_ADDED,
        payload: test
    }
}

function officialTestUpdated(test){
    return {
        type: OFFICIAL_TEST_UPDATED,
        payload: test
    }
}

function officialTestDeleted(testId){
    return {
        type: OFFICIAL_TEST_DELETED,
        payload: testId
    }
}

export function getOfficialTests(profileId, token){
    return dispatch => {
        api.getOfficialTests(profileId, token, res => {
            if(res.data){
                dispatch(officialTestsRetrieved(res.data));
            }
        })
    }
}

export function updateOfficialTest(test, token){
    return dispatch => {
        if(test.id){
            api.updateOfficialTest(test, token, res => {
                if(res.data){
                    dispatch(officialTestUpdated(res.data));
                }
            })
        }else{
            api.addOfficialTest(test, token, res => {
                if(res.data){
                    dispatch(officialTestAdded(res.data));
                }
            })
        }
    }
}

export function deleteOfficialTest(testId, token){
    return dispatch => {
        api.deleteOfficialTest(testId, token, res => {
            dispatch(officialTestDeleted(testId));
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/authActions.js